<template>
  <!-- TODO refactor to use Completed.vue -->
  <ion-page>
    <ion-content fullscreen="true" class="launch-page">
      <!-- Content here  -->
      <div class="main-header">
        <div class="pt-[100px] px-[22px]">
          <div class="small-text text-[#433D31]">Welcome, Nicholas</div>
          <img src="/assets/images/launch/welcome-text.webp" />
        </div>
      </div>
      <ion-card class="rounded-[20px] text-center info-card mx-[32px]">
        <ion-card-header class="pb-[4px]">
          <ion-card-title class="title">Turn on Notifications 🔔</ion-card-title>
        </ion-card-header>

        <ion-card-content class="description">
          Get real-time updates, exclusive insights, and timely reminders.
        </ion-card-content>
      </ion-card>
      <ion-card class="rounded-[20px] text-center info-card mx-[32px]">
        <ion-card-header class="pb-[4px]">
          <ion-card-title class="title">Keep your profile updated 💁🏻💁🏻‍♀️</ion-card-title>
        </ion-card-header>

        <ion-card-content class="description">
          Update it for personalised updates and a seamless experience!
        </ion-card-content>
      </ion-card>

      <ion-footer class="ion-no-border absolute bottom-[0px] py-[32px] px-[24px]">
        <ion-button
          expand="block"
          shape="round"
          class="next-button"
          fill="solid"
          @click="requestNotificationPermission"
        >
          Let’s go
        </ion-button>
      </ion-footer>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonPage } from '@ionic/vue';
import { requestNotificationPermission as requestOneSignalNotificationPermission } from '@/utils/notification';
import { oneSignalExternalId } from '@/utils/onesignal-external-id';

export default {
  name: 'SuccessLaunchPage',
  components: {
    IonPage,
    IonContent,
  },
  methods: {
    async requestNotificationPermission() {
      try {
        const register = this.$store.state.profile.register;
        const memberId =
          oneSignalExternalId(this.$store.state.profile) ||
          register?.memberId ||
          register?.id ||
          register?.userId;
        await requestOneSignalNotificationPermission(memberId);
      } catch (error) {
        console.error('Error requesting permission:', error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
ion-content {
  --background: #f1f1f1;
}
.launch-page {
  --padding: 32px;
  .next-button {
    --background: #3d3a35;
    font-size: 16px;
    height: 56px;
  }
  .main-header {
    background-image: url('/assets/images/launch/bg-header.webp');
    background-repeat: no-repeat;
    height: 50vh;
    background-size: cover;
    background-position: center;
  }
  .small-text {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
  .big-text {
    font-weight: 900;
    font-size: 50px;
    line-height: 55px;
    text-align: center;
  }
  .info-card {
    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
    .description {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
  }
}
</style>
